import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import GuideImage from "../../images/transactionalCredit/guide.png"
const Guide=({onConfirm,text})=>{
    return <div className="bg-gray-50  w-full min-h-screen">
            <div className="content flex  pt-8 flex-col items-center justify-center ">
                <h1 className="text-2xl  font-bold text-gray-500 mb-4 ">{text.title}</h1>
                <img className="w-7/12 md:w-6/12 lg:w-3/12"  src={GuideImage} alt=""/>
                <h1 className="text-xl mt-8 font-semibold   text-gray-800 ">{text.subTitle}</h1>
                <p className="w-10/12 lg:w-5/12 md:w-6/12 text-center mt-1  text-gray-600 ">{text.description}</p>
            </div>

            <BottomButtonWrapper >
                <Button theme="green" onClick={onConfirm} rounded="rounded-xl ">ادامه</Button>
            </BottomButtonWrapper>
        </div>
}
export default Guide;